import { Link, NavLink } from 'react-router-dom';

import styled from 'styled-components';

import { Container } from '../../styles/Common';

const NavbarDesktop = () => {
  return (
    <Wrapper>
      <Container>
        <NavWrapper>
          <LogoLink to="/">
            <img src="/assets/icons/logo.png" alt="logo" />
          </LogoLink>
          <MenuWrapper>
            <li>
              <NavLink to="/fulfillment">FULFILLMENT</NavLink>
            </li>
            <li>
              <NavLink to="/marketing">MARKETING</NavLink>
            </li>
          </MenuWrapper>
          <div>
            <ContactUsButtonWrapper
              href="https://calendly.com/info-ripify"
              target="_blank"
            >
              <span>Contact Us</span>
            </ContactUsButtonWrapper>
          </div>
        </NavWrapper>
      </Container>
    </Wrapper>
  );
};

export default NavbarDesktop;

const Wrapper = styled.div`
  padding-top: 30px;

  @media (max-width: 1024px) {
    padding-top: 20px;
  }
`;

const NavWrapper = styled.nav`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LogoLink = styled(Link)<any>`
  img {
    width: 190px;
    height: auto;
    user-select: none;
    cursor: pointer;

    @media (max-width: 1024px) {
      width: 130px;
    }
  }
`;

const MenuWrapper = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;

  li {
    margin: 0 25px;

    a {
      text-decoration: none;
      font-weight: 600;
      font-size: 22px;
      font-family: font-semibold;
      color: #000;
      transition: 0.3s;
      display: block;
      position: relative;

      @media (max-width: 1024px) {
        font-size: 18px;
      }

      &:after {
        position: absolute;
        content: '';
        width: 0;
        height: 2px;
        background-color: #5ca9ed;
        bottom: -5px;
        left: 0;
        transition: 0.3s;
      }

      &:hover,
      &.active {
        &:after {
          width: 100%;
        }
      }
    }
  }
`;

const ContactUsButtonWrapper = styled.a<any>`
  padding: 2px 2px 1.5px 2px;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    96.91deg,
    #5ca6ed 0%,
    #5f60ef 48.46%,
    #b174f8 100%
  );

  @media (max-width: 1024px) {
    padding: 2px 2px 2.3px 2px;
  }

  span {
    background-color: #edf2f5;
    padding: 22px 25px;
    font-family: font-medium;
    font-size: 15px;
    font-weight: 500;
    color: #000;
    transition: 0.3s;
    letter-spacing: 3px;

    @media (max-width: 1024px) {
      padding: 18px 23px;
    }
  }

  &:hover {
    span {
      background-color: rgba(237, 242, 245, 0);
      color: #fff;
    }
  }
`;
